import { useSiteImage } from "@/hooks/useSiteImages";
import React from "react";
import { PublicNav, PublicFooter } from "@/components/PublicChrome";
import OralChampionSection from "@/components/OralChampionSection";
import { Video, Clock, Award, CheckCircle2 } from "lucide-react";

export default function OralChampion() {
  const imgOCPage = useSiteImage("oral_champion_page", "https://customer-assets-cm19k8pv.emergentagent.net/job_care-cert-hub/artifacts/de285c2b4e9300a2_me%20webinar.jpeg");
  return (
    <div className="min-h-screen bg-cream font-body">
      <PublicNav />
      <section className="max-w-7xl mx-auto px-5 md:px-8 pt-16 pb-14 grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <span className="label-caps text-coral">Live · 3-hour online course · monthly</span>
          <h1 className="text-4xl md:text-5xl font-bold text-brand tracking-tight mt-3">Oral Champion Training</h1>
          <p className="text-lg text-muted-foreground mt-4 leading-relaxed">Train a member of your team to lead better oral healthcare and support colleagues to get mouth care right. CQC's Smiling Matters report recommends an Oral Champion in every care home.</p>
          <div className="mt-6 rounded-2xl bg-brand text-white p-5">
            <div className="flex items-start gap-3"><CheckCircle2 className="h-6 w-6 text-coral flex-shrink-0" />
              <div><div className="font-semibold">One Oral Champion per care home is included in your subscription.</div>
              <div className="text-white/70 text-sm mt-1">Additional champions are trained at a <span className="text-coral font-semibold">50% discounted rate — £42.50</span> each (normally £85). Great for part-time staff or multiple shifts.</div></div>
            </div>
          </div>
          <div className="flex flex-wrap gap-6 mt-6">
            <div className="flex items-center gap-2"><Clock className="h-5 w-5 text-brand" /><span className="text-sm">3-hour live session</span></div>
            <div className="flex items-center gap-2"><Video className="h-5 w-5 text-brand" /><span className="text-sm">Delivered on Zoom</span></div>
            <div className="flex items-center gap-2"><Award className="h-5 w-5 text-brand" /><span className="text-sm">Certificate on completion</span></div>
          </div>
        </div>
        <div className="rounded-3xl overflow-hidden border border-cream-deep shadow-xl">
          <img src={imgOCPage} alt="Jane delivering a live Oral Champion training webinar" className="w-full h-[400px] object-cover" />
        </div>
      </section>

      <OralChampionSection showTestimonials />

      <PublicFooter />
    </div>
  );
}
